module.exports = __webpack_public_path__ + "static/media/icn-upload-avatar--dark.5a866068.svg";